export const colorOptions = [
    {
        name: "Blue on White",
        bgcolor: "#ffffff",
        fgcolor: "#002E4F",
    },
    
    {
        name: "White on Blue",
        bgcolor: "#002E4F",
        fgcolor: "#ffffff",
    },
    
    {
        name: "Blue on Eggshell Cream",
        bgcolor: "#FAF2E3",
        fgcolor: "#002E4F",
    },
    
]